import React from 'react';
import styled from 'styled-components';

import Heading from '../../components/heading';

/**
 * Container element
 */
const Container = styled.div`
  padding: 0.5em 2.5em;
  align-self: stretch;
  line-height: 1.5;
`;

/**
 * Small Heading element
 */
export const SmallHeading = styled.h2`
  font-size: 1.2em;
  margin-top: 1.2em;
`;

/**
 * Link element
 */
const Link = styled.a`
  color: white;
`;

const LastUpdated = styled.p`
  text-align: right;
`;

const Table = styled.table`
  border: 1px solid;
  border-collapse: collapse;
  td,
  th {
    vertical-align: top;
    border: 1px solid white;
    padding: 0.5em;
  }
`;

const List = styled.ul`
  padding-left: 2em;
  margin: 0;
  li {
    margin-bottom: 1em;
  }
`;
/**
 * Privacy Policy function
 */
const PrivacyPolicy = () => {
  return (
    <Container>
      <Heading>プライバシーポリシー</Heading>
      <p>
        プレティア・テクノロジーズ株式会社（以下「当社」といいます。）は、本プライバシーポリシーに従って、個人情報（個人情報の保護に関する法律（以下「個人情報保護法」といいます。）第２条第１項に定める個人情報を意味します。以下同じ。）を取り扱うものとします。
      </p>
      <SmallHeading>1 基本方針</SmallHeading>
      <p>
        当社は、個人情報保護法を遵守するとともに、組織体制を整備し、個人情報の適切な保護に努めて参ります。
      </p>
      <SmallHeading>２ 個人情報の適切な取得</SmallHeading>
      <p>
        当社は、個人情報を取得する場合には、適性かつ公正な方法にてこれを行うものとします。また、当社は、予め同意を得た場合または法令で認められる場合を除き、要配慮個人情報を取得しません。
      </p>
      <SmallHeading>３ 適切な措置の実施</SmallHeading>
      <p>
        当社は、保有する個人情報に関し、合理的な安全措置をとることによって、不正アクセス、漏洩等を防止し、適切な措置をとるよう努めます。
      </p>
      <SmallHeading>４ 利用目的</SmallHeading>
      <p>
        当社は、個人情報を以下の目的で利用します。個人情報保護法その他の法令により認められる事由がある場合、本人（個人情報保護法第２条第８項に定義される「本人」を意味します。以下同じ。）の同意がある場合又は別途利用目的を通知・公表している場合を除き、以下の目的以外に個人情報を利用することはありません。なお、当社が提供するサービスの利用規約等において、個人情報の利用目的を別途定めている場合には、当該利用目的も含むものとします。
      </p>
      <Table>
        <thead>
          <th>情報の種類</th>
          <th>利用目的</th>
        </thead>
        <tbody>
          <tr>
            <td>
              顧客情報、ユーザー情報（ログ情報、デバイス情報、位置情報、購入情報等を含みます。）
            </td>
            <td>
              <List>
                <li>
                  当社のサービス、商品等（以下「当社サービス等」といいます。）における本人確認のため
                </li>
                <li>当社サービス等を提供するため</li>
                <li>
                  本人が効率よく自分自身の情報にアクセスできるようにするため
                </li>
                <li>
                  本人が一度入力した情報を保存しておき、必要となる際に再度情報を入力しなくても済むようにするため
                </li>
                <li>当社サービス等に関する情報提供のため</li>
                <li>当社サービスの広告又は宣伝、マーケティングのため</li>
                <li>統計データ等、個人を特定できないデータを作成するため</li>
                <li>
                  当社サービス等を改善するため（不正行為の監視、対策等も含みます。）
                </li>
                <li>当社の新しいサービス等を研究・開発するため</li>
                <li>契約、利用規約等で禁じている行為等の調査・対応のため</li>
                <li>お問い合わせへの対応のため</li>
                <li>
                  当社サービス等の購入の確認、お届け、アフターサービスを行うため
                </li>
                <li>本人確認のため</li>
                <li>上記目的に付随する目的のため</li>
              </List>
            </td>
          </tr>
          <tr>
            <td>従業員情報</td>
            <td>
              <List>
                <li>労務管理、社内手続のため</li>
                <li>給与、賞与等の支払のため</li>
                <li>業務上の連絡のため</li>
                <li>官公庁への届出、報告等のため</li>
                <li>
                  就業規則、雇用契約等で禁じている行為等の調査・対応のため
                </li>
                <li>上記目的に付随する目的のため</li>
              </List>
            </td>
          </tr>
          <tr>
            <td>採用応募者情報</td>
            <td>
              <List>
                <li>採用選考、日程等のご連絡、採用結果の通知のため</li>
                <li>入社手続実施のため</li>
                <li>上記目的に付随する目的のため</li>
              </List>
            </td>
          </tr>
          <tr>
            <td>業務委託先情報</td>
            <td>
              <List>
                <li>業務上の連絡のため</li>
                <li>業務委託料等の支払のため</li>
                <li>契約等で禁じている行為等の調査・対応のため</li>
                <li>上記目的に付随する目的のため</li>
              </List>
            </td>
          </tr>
          <tr>
            <td>株主情報</td>
            <td>
              <List>
                <li>会社法その他の法令に基づいた株主管理のため</li>
                <li>株主への通知、連絡のため</li>
                <li>官公庁への届出、報告等のため</li>
                <li>上記目的に付随する目的のため</li>
              </List>
            </td>
          </tr>
        </tbody>
      </Table>
      <SmallHeading>５ 第三者提供</SmallHeading>
      <p>
        当社は個人情報保護法その他の法令により認められる場合を除き、個人情報の第三者提供を行いません。当社は、個人番号及び特定個人情報（個人番号をその内容に含む個人情報をいいます。）については、法令で認められた事務のためにのみ利用し、法令で認められる場合を除き、第三者に提供しません。
      </p>
      <SmallHeading>６ 個人情報の取り扱いの委託</SmallHeading>
      <p>
        個人情報の取り扱いを外部へ委託する場合には、適切な安全管理が図られるよう契約により義務付けるなどすることにより、必要かつ適切な監督を実施します。
      </p>
      <SmallHeading>７ 匿名加工情報</SmallHeading>
      <p>
        当社は、法令に従い匿名加工情報（個人情報保護法で定義する「匿名加工情報」をいいます。）を取り扱います。
      </p>
      <SmallHeading>８ 個人情報の開示、訂正等の請求</SmallHeading>
      <p>
        当社は、保有する個人情報について、個人情報保護法に基づく開示、訂正・追加・削除、利用停止・消去等の請求があった場合、請求された方が本人であることを確認した後、個人情報保護法に従って対応いたします。かかる請求を行う場合、第９項の窓口にご連絡下さい。
      </p>
      <SmallHeading>９ お問い合わせ窓口</SmallHeading>
      <p>
        個人情報の取扱いに関するお問い合わせは、下記の窓口までお願い致します。
      </p>
      <p>
        〒141-0033 東京都品川区西品川1-1-1
        <br />
        プレティア・テクノロジーズ株式会社
        <br />
        Email:{' '}
        <Link href="mailto:privacy@pretia.co.jp">privacy@pretia.co.jp</Link>
      </p>
      <SmallHeading>
        １０ クッキー情報及びGoogleアナリティクスの利用 について
      </SmallHeading>
      <p>
        当社は、設定内容の保存等ユーザーの利便性向上のため、セッションの維持及び保護等セキュリティのため、ユーザーが利用した本サービスに対する訪問回数及び利用形態、ユーザーの規模等の把握により、より良いサービスを提供するためにクッキーを利用いたします。また、本サービスではGoogle
        Analyticsを利用する場合がございます。データの収集、処理方法等のGoogle
        Analyticsの詳細については、下記のURLをご参照ください。ユーザーはクッキーの使用可否を選択できますが、クッキーの保存を拒む場合には、本サービスの一部をご利用いただけない場合がございます。
        <br />
        <Link href="https://marketingplatform.google.com/about/analytics/terms/jp/">
          https://marketingplatform.google.com/about/analytics/terms/jp/
        </Link>
      </p>
      <SmallHeading>１１ 他のWebサイトへのリンクについて</SmallHeading>
      <p>
        当社の運営いたしますWebサイトにリンクされている第三者のWebサイトにおける個人情報について、当社は、一切の責任を負いません。
      </p>
      <SmallHeading>１２ 未成年からの個人情報のご提供について</SmallHeading>
      <p>
        未成年から個人情報を提供していただく場合は、必要に応じて、保護者の方の同意を得ていただく場合があります。
      </p>
      <SmallHeading>１３ お願い</SmallHeading>
      <p>
        当社サービス等では、ユーザーの情報をID・パスワードで保護している場合があります。ID・パスワードの管理は、ユーザーご自身が責任を持って行ってください。当社サービス等を安全にご利用いただけるよう、他の方やユーザーご自身の個人情報は開示又は公表されないようお願いいたします。
      </p>
      <SmallHeading>１４ 本プライバシーポリシーの変更</SmallHeading>
      <p>
        当社は、必要に応じて、本プライバシーポリシーを変更することがあります。
      </p>
      <LastUpdated>令和4年1月18日改定</LastUpdated>
    </Container>
  );
};

export default PrivacyPolicy;
